const posts = [
    {
        id: 1,
        name: "First Example School",
        lga: "Oshodi-Isolo",
        state: "Lagos",
        school_id: "FES-OL",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/Ellipse 5.png")
    },

    {
        id: 2,
        name: "Second Example School",
        lga: "Abuja Municipal",
        state: "FCT-Abuja",
        school_id: "SES-FCTA",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/cairo.png")
    },

    {
        id: 3,
        name: "Third Example School",
        lga: "Nembe",
        state: "Bayelsa",
        school_id: "TES-NB",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/cropped-School-Badge 1.png")
    },

    {
        id: 4,
        name: "Fourth Example School",
        lga: "Bogoro",
        state: "Bauchi",
        school_id: "FES-BB",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/122-1224567_stafford-county-public-school-logo-best-logo-for 1.png")
    },

    {
        id: 5,
        name: "Fifth Example School",
        lga: "Offa",
        state: "Kwara",
        school_id: "FES-OK",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/Ellipse 6.png")
    },

    {
        id: 6,
        name: "Sixth Example School",
        lga: "Ilorin West",
        state: "Kwara",
        school_id: "SES-IK",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/kuala.png")
    },

    {
        id: 7,
        name: "Seventh Example School",
        lga: "Abeokuta South",
        state: "Ogun",
        school_id: "SES-AO",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/OakfieldLogo 1.png")
    },

    {
        id: 8,
        name: "Eighth Example School",
        lga: "Atiba",
        state: "Oyo",
        school_id: "EES-AO",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/png-transparent-british-international-school-in-cairo.png")
    },

    {
        id: 9,
        name: "Ninth Example School",
        lga: "Egbeda",
        state: "Oyo",
        school_id: "NES-EO",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/png-transparent-british-international-school-of-kuala.png")
    },

    {
        id: 10,
        name: "Tenth Example School",
        lga: "Andoni",
        state: "Rivers",
        school_id: "TES-AR",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/preload.png")
    },

    {
        id: 11,
        name: "Eleventh Example School",
        lga: "Bida",
        state: "Niger",
        school_id: "EES-BN",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/preloader 1.png")
    },

    {
        id: 12,
        name: "Twelveth Example School",
        lga: "Sabon-Gari",
        state: "Kaduna",
        school_id: "TES-SK",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/Rectangle 67.png")
    },

    {
        id: 13,
        name: "Thirteenth Example School",
        lga: "Jega",
        state: "Kebbi",
        school_id: "TES-JK",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/Rectangle 68.png")
    },

    {
        id: 14,
        name: "Fourteenth Example School",
        lga: "Gireri",
        state: "Adamawa",
        school_id: "FES-IL",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/School_Logo_1 1.png")
    },

    {
        id: 15,
        name: "Fifteenth Example School",
        lga: "Ogbaru",
        state: "Anambra",
        school_id: "FES-OA",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/School-Badge.png")
    },

    {
        id: 16,
        name: "Sixteenth Example School",
        lga: "Nkanu",
        state: "Enugu",
        school_id: "SES-NE",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/stafford-county-public-school.png")
    },

    {
        id: 17,
        name: "Seventeenth Example School",
        lga: "Abuja Municipal",
        state: "FCT-Abuja",
        school_id: "SES-FCTA",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/Rectangle 67.png")
    },

    {
        id: 18,
        name: "Eighteenth Example School",
        lga: "Abuja Municipal",
        state: "FCT-Abuja",
        school_id: "EES-FCTA",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/cairo.png")
    },

    {
        id: 19,
        name: "Nineteenth Example School",
        lga: "Abuja Municipal",
        state: "FCT-Abuja",
        school_id: "NES-FCTA",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/preloader 1.png")
    },

    {
        id: 20,
        name: "Twentieth Example School",
        lga: "Isolo",
        state: "Lagos",
        school_id: "TES-IL",
        message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id molestias in cum! Veniam velit ullam necessitatibus aliquid veritatis rerum, " +
            "praesentium fuga, repellendus excepturi, exercitationem nostrum laborum autem dolore. Eius provident exercitationem ea quisquam. Quo vero fuga nisi " +
            "perferendis aliquid sequi ea ducimus ipsa numquam porro ratione, modi odit dolorum in.",
        likes: ["Second Example School", "Fifth Example School", "Ninth Example School", "Twentieth Example School", "Eighth Example School", "Sixth Example School",],
        comment: [
            {
                id: 1,
                school: "Second Example School",
                lga: "Abuja Municipal",
                state: "FCT-Abuja",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/cairo.png"),
            },
            {
                id: 2,
                school: "Fifth Example School",
                lga: "Offa",
                state: "Kwara",
                text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam voluptatem beatae veritatis facere molestias voluptas.",
                image: require("./img/Ellipse 6.png"),
            },
            {
                id: 3,
                school: "Ninth Example School",
                lga: "Egbeda",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-of-kuala.png"),
            },
            {
                id: 4,
                school: "Twentieth Example School",
                lga: "Ikeja",
                state: "Lagos",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/OakfieldLogo 1.png"),
            },
            {
                id: 5,
                school: "Eighth Example School",
                lga: "Atiba",
                state: "Oyo",
                text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, laboriosam!",
                image: require("./img/png-transparent-british-international-school-in-cairo.png"),
            },
        ],
        day: "17/09/2022",
        time: "2:15 pm",
        image: require("./img/OakfieldLogo 1.png")
    },
]

export { posts }